import React from 'react';
import { CheckCircle2Icon, BookOpenIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function WhatYouGet() {
  const deliverables = [{
    title: 'El Protocolo de Emergencia de 3 Minutos',
    description: 'La secuencia exacta paso a paso para ejecutar en la cama cuando el pánico nocturno ataca.'
  }, {
    title: 'Guía de Blindaje del Dormitorio',
    description: 'Cómo transformar tu habitación en una cámara de sueño de bajo costo.'
  }, {
    title: 'El Método de Respiración 4-8-7 Modificado',
    description: 'La técnica para sedar el sistema nervioso en menos de 120 segundos.'
  }, {
    title: "Protocolo 'Despertar sin Niebla'",
    description: 'Qué hacer en los primeros 10 minutos de la mañana para rescatar tu energía tras una mala noche.'
  }, {
    title: 'Checklist de Apagado Digital',
    description: 'El sistema para preparar tu cerebro antes de tocar la almohada.'
  }];
  return <section className="py-16 md:py-24 bg-slate-800" data-id="element-180">
      <div className="max-w-5xl mx-auto px-4" data-id="element-181">
        <div className="flex flex-col md:flex-row gap-12 items-center" data-id="element-182">
          <div className="w-full md:w-1/2" data-id="element-183">
            <div className="inline-flex items-center gap-2 text-blue-400 font-semibold tracking-wider uppercase text-sm mb-4" data-id="element-184">
              <BookOpenIcon className="w-5 h-5" data-id="element-185" />
              <span data-id="element-186">Contenido del Programa</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-187">
              Lo que recibes hoy mismo
            </h2>

            <div className="space-y-6" data-id="element-188">
              {deliverables.map((item, index) => <div key={index} className="flex gap-4" data-id="element-189">
                  <CheckCircle2Icon className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" data-id="element-190" />
                  <div data-id="element-191">
                    <h3 className="text-lg font-bold text-white mb-1" data-id="element-192">
                      {item.title}
                    </h3>
                    <p className="text-slate-400" data-id="element-193">{item.description}</p>
                  </div>
                </div>)}
            </div>

            <div className="mt-10" data-id="element-194">
              <CTAButton data-id="element-195" />
            </div>
          </div>

          <div className="w-full md:w-1/2 relative" data-id="element-196">
            <div className="absolute inset-0 bg-blue-500/20 blur-3xl rounded-full" data-id="element-197" />
            <img src="https://cdn.magicpatterns.com/uploads/jRPM3wwhqZdPRBZFbQeHvg/ADIOS_INSOMNIO_3AM.png" alt="Contenido del Protocolo Adiós Insomnio" className="relative rounded-2xl shadow-2xl border border-slate-700 w-full object-cover" data-id="element-198" />
          </div>
        </div>
      </div>
    </section>;
}